import { useState } from "react";

//import material
import {
  Card,
  Grid,
  Typography,
  IconButton,
  Dialog,
  DialogContent,
  Divider,
  Tooltip,
  ToggleButtonGroup,
  ToggleButton,
  useTheme,
  Box,
  Chip,
  Button,
  Snackbar,
  Alert,
} from "@mui/material";
import DriveFileRenameOutlineOutlinedIcon from "@mui/icons-material/DriveFileRenameOutlineOutlined";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
//project components
import InformationText from "./InformationText";
import GeneralInfoForm from "./GeneralInfoForm";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { convertDateToLocal } from "../../../../utils/date-operations";
import { axiosAuth } from "../../../../api";

const GeneralInfo = (props) => {
  //Constant
  const theme = useTheme();
  const { candidate, onSave, onCancel } = props;
  const navigate = useNavigate();
  const { userId, profileId, userName, role, displayRole } = useSelector(
    (state) => state.userReducer
  );

  //States
  const [openForm, setOpenForm] = useState(false);
  const [isAvailable, setIsAvailable] = useState(
    candidate?.isCandidateAvailable
  );
  const [isLoading, setIsLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  //Methods
  const handleCancel = () => {
    setOpenForm(false);
  };
  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };
  const handleSave = () => {
    setOpenForm(false);
    onSave();
  };
  const handleAvailabilityChange = async (event, newValue) => {
    if (newValue === null || isLoading) return; // Prevent unselecting both buttons and multiple clicks

    const newAvailability = newValue === "available";
    setIsLoading(true);

    try {
      // Call the API to update availability
      const response = await axiosAuth.put(
        "/api/Candidates/update-isavaialbe?id=" +
          candidate?.id +
          "&isAvailable=" +
          newAvailability // Changed from true to newAvailability
      );

      // Update local state if API call succeeds
      setIsAvailable(newAvailability);
      onSave(); // Notify parent component of the change

      setSnackbar({
        open: true,
        message: `Candidate marked as ${
          newAvailability ? "available" : "not available"
        } successfully!`,
        severity: "success",
      });
    } catch (error) {
      console.error("Failed to update availability:", error);
      // Revert the UI change if API call fails
      setIsAvailable(!newAvailability);
      setSnackbar({
        open: true,
        message: "Failed to update candidate availability",
        severity: "error",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Card elevation={3}>
        <Grid
          sx={{
            background: "linear-gradient(to right,#4a7dcf 0%, #2a569f 100%)",
            paddingX: 2,
            paddingY: 0.5,
          }}
        >
          <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Grid item>
              <Typography
                variant="h6"
                sx={{
                  color: "#ffffff",
                }}
              >
                Personal Information
              </Typography>
            </Grid>
            {role !== 4 && (
              <Grid item>
                <Tooltip title="Edit">
                  <IconButton
                    onClick={() => {
                      // setOpenForm(true);
                      navigate("/admin/candidates/form?Id=" + candidate?.id);
                    }}
                  >
                    <DriveFileRenameOutlineOutlinedIcon
                      sx={{ color: "#ffffff" }}
                    />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Back">
                  <IconButton
                    sx={{ color: "#ffffff" }}
                    onClick={() => {
                      navigate("/admin/candidates");
                    }}
                  >
                    <ArrowBackIcon />
                  </IconButton>
                </Tooltip>
              </Grid>
            )}
          </Grid>
        </Grid>
        <Grid container spacing={4} sx={{ padding: 3 }}>
          <Grid item sm={4} xs={12}>
            <InformationText
              dataOf="Full Name"
              data={`${candidate.salutation} ${candidate.firstName} ${candidate.middleName} ${candidate.lastName}`}
            />
          </Grid>
          <Grid item sm={4} xs={12}>
            <InformationText
              dataOf="Email"
              data={candidate.email ? candidate.email : "--"}
            />
          </Grid>
          <Grid item sm={4} xs={12}>
            <InformationText
              dataOf="Date of Birth"
              data={convertDateToLocal(candidate.dateOfBirth)}
            />
          </Grid>
          <Grid item sm={4} xs={12}>
            <InformationText
              dataOf="Mobile Number"
              data={candidate.phoneNumber ? candidate.phoneNumber : "--"}
            />
          </Grid>
          <Grid item sm={4} xs={12}>
            <InformationText dataOf="Gender" data={candidate.gender} />
          </Grid>
          <Grid item sm={4} xs={12}>
            <InformationText
              dataOf="Maritial Status"
              data={candidate.marritalStatus}
            />
          </Grid>
          <Grid item sm={4} xs={12}>
            <InformationText
              dataOf="Aadhar Number"
              data={candidate.aadharNumber}
            />
          </Grid>
          <Grid item sm={4} xs={12}>
            <InformationText
              dataOf="Registration Date"
              data={candidate.createDate ? convertDateToLocal(candidate.createDate) : "--"}
            />
          </Grid>
        </Grid>
        <Divider sx={{ marginY: 1 }} />
        <Grid container spacing={4} sx={{ padding: 3 }}>
          <Grid item sm={4} xs={12}>
            <InformationText
              dataOf="Address"
              data={candidate.addressLine1 + ", " + candidate.addressLine2}
            />
          </Grid>

          <Grid item sm={4} xs={12}>
            <InformationText
              dataOf="City"
              data={candidate.city ? candidate.city : "--"}
            />
          </Grid>
          <Grid item sm={4} xs={12}>
            <InformationText
              dataOf="Taluka"
              data={candidate.taluka ? candidate.taluka : "--"}
            />
          </Grid>
          <Grid item sm={4} xs={12}>
            <InformationText
              dataOf="District"
              data={candidate.district ? candidate.district : "--"}
            />
          </Grid>
          <Grid item sm={4} xs={12}>
            <InformationText
              dataOf="State"
              data={candidate.state ? candidate.state : "--"}
            />
          </Grid>
        </Grid>

        <Divider sx={{ marginY: 1 }} />
        <Grid container spacing={4} sx={{ padding: 3 }}>
          <Grid item sm={4} xs={12}>
            <InformationText
              dataOf="Job Experience"
              data={candidate.jobExperienceDisplay}
            />
          </Grid>
          <Grid item sm={4} xs={12}>
            <InformationText
              dataOf="Current Job Status"
              data={candidate.currentJobStatusDisplay}
            />
          </Grid>
          <Grid item sm={4} xs={12}>
            <InformationText dataOf="Skills" data={candidate.skills} />
          </Grid>
          <Grid item sm={4} xs={12}>
            <InformationText
              dataOf="Language Known"
              data={candidate.languageKnown ? candidate.languageKnown : "--"}
            />
          </Grid>
          {/* <Grid item sm={4} xs={12}>
            <Typography variant="body1" style={{ marginRight: 8 }}>
              Registration Status
            </Typography>

            <Chip
              label={candidate.registrationStatusDisplay}
              color={candidate.registrationStatus === 1 ? "success" : "warning"}
              variant="outlined"
            />
          </Grid> */}
          <Grid item sm={4} xs={12}>
            <InformationText
              dataOf="Guardian Name"
              data={candidate.guardianName ? candidate.guardianName : "--"}
            />
          </Grid>
          <Grid item sm={4} xs={12}>
            <InformationText
              dataOf="Guardian Phone Number"
              data={
                candidate.guardianPhoneNumber
                  ? candidate.guardianPhoneNumber
                  : "--"
              }
            />
          </Grid>
          <Grid item sm={4} xs={12}>
            <InformationText
              dataOf="Reference Name"
              data={candidate.referenceName ? candidate.referenceName : "--"}
            />
          </Grid>
          <Grid item sm={4} xs={12}>
            <InformationText
              dataOf="Reference Phone Number"
              data={
                candidate.referencePhoneNumber
                  ? candidate.referencePhoneNumber
                  : "--"
              }
            />
          </Grid>
          {role === 1 && (
            <Grid item sm={4} xs={12}>
              <Tooltip title="Candidate availability status">
                <Typography>Is Candidate Available?</Typography>
                <ToggleButtonGroup
                  value={isAvailable ? "available" : "not-available"}
                  exclusive
                  onChange={handleAvailabilityChange}
                  aria-label="Candidate availability"
                  sx={{ mr: 1 }}
                  disabled={isLoading}
                >
                  <ToggleButton
                    value="available"
                    aria-label="available"
                    color="primary"
                    selected={isAvailable}
                  >
                    Available
                  </ToggleButton>
                  <ToggleButton
                    value="not-available"
                    aria-label="not available"
                    color="primary"
                    selected={!isAvailable}
                  >
                    Not Available
                  </ToggleButton>
                </ToggleButtonGroup>
              </Tooltip>
            </Grid>
          )}
        </Grid>
      </Card>
      {/* <Dialog open={openForm} onClose={handleCancel} fullWidth maxWidth="md">
        <DialogContent>
          <GeneralInfoForm
            onSave={handleSave}
            onCancel={handleCancel}
            candidate={candidate}
          />
        </DialogContent>
      </Dialog> */}

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
          sx={{
            width: "100%",
            bgcolor:
              snackbar.severity === "success" ? "success.main" : "error.main",
            color: "common.white",
          }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default GeneralInfo;
